import {  Analytic, TagSetup } from '../../automaton-tags';

export const getAnalyticalTags = (tagSetup: Record<string, TagSetup>) => Object.keys(tagSetup)
    .map(key => (tagSetup[key].analytics ? {...tagSetup[key].analytics, tag: key } : null))
    .filter((e):e is Analytic & { tag: string} => !!e)
    .sort((a, b) => (a.sortOrder - b.sortOrder));
